export function action () {
  return dispatch => {
    dispatch({type:'UPDATE_HEADER'})
  }
}